import { render, staticRenderFns } from "./MyTab.vue?vue&type=template&id=16d104fc&scoped=true"
import script from "./MyTab.vue?vue&type=script&lang=js"
export * from "./MyTab.vue?vue&type=script&lang=js"
import style0 from "./MyTab.vue?vue&type=style&index=0&id=16d104fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d104fc",
  null
  
)

export default component.exports